module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Part-Number-pn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_27",
      "title": "27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Colonna-MT"
  }, [_vm._v("PART I")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Title-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BY THE WATERS OF BABYLON")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Like a picture it seemed of the primitive, pastoral ages,")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fresh with the youth of the world, and recalling Rebecca and Isaac,")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Old and yet ever new, and simple and beautiful always,")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Love immortal and young in the endless succession of lovers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-Source-peps"
  }, [_vm._v("—Henry Wadsworth Longfellow")]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Joyance is come, dispelling cark and care;")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("We are united, enviers may despair …")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("One hour of joyance made us both forget")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("What from excess of terror grey’d our hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-Source-peps"
  }, [_vm._v("—from Richard Burton’s translation of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("One Thousand and One Nights")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("cras amet qui numquam amavit")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-verse-pepiv_pt"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("quique amavit cras amet")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Epigraph-Source-peps"
  }, [_vm._v("—“The Vigil of Venus”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab456b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 81
// module chunks = 0